import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import { QUERY_KEYS } from '@/remote/query-key';
import type {
  SiteInspectionApiResponse,
  SiteInspectionResponse,
  UpdateSiteInspectionDto,
} from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateInspectionParams {
  id: string;
  data: UpdateSiteInspectionDto;
}

export const useUpdateInspectionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.inspections.updateInspection],
    mutationFn: async ({
      id,
      data,
    }: UpdateInspectionParams): Promise<SiteInspectionResponse> => {
      const response = await XHRAuthorizedClient.put<SiteInspectionApiResponse>(
        ENDPOINTS.inspections.update(id),
        data
      );
      return response.data.data;
    },
    onSuccess: (updatedData, { id }) => {
      // 특정 점검 기록 캐시 업데이트
      queryClient.setQueryData(
        QUERY_KEYS.inspections.getDetail(id),
        updatedData
      );

      queryClient.invalidateQueries();
    },
  });
};
